import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getItemAlertsData } from "src/api/sp";
import { resetStore } from "src/store/actions";

export const fetchItemAlertsData = createAsyncThunk(
  "dashboard/fetchItemAlertsData",
  ({
    department,
    storeId,
    countDate
  }: {
    department: string;
    storeId: string;
    countDate: string;
  }) => {
    return getItemAlertsData({ department, storeId, countDate });
  }
);

type ItemAlertsInitialStates = {
  status: string;
  itemAlertsData: { name: string; value: number }[];
  error: string;
};

const initialState: ItemAlertsInitialStates = {
  status: "idle",
  itemAlertsData: [],
  error: ""
};

const itemAlertsSlice = createSlice({
  name: "itemAlerts",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchItemAlertsData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchItemAlertsData.fulfilled, (state, { payload }) => {
        state.status = "idle";
        state.itemAlertsData = payload.data;
      })
      .addCase(fetchItemAlertsData.rejected, (state, action) => {
        state.status = "error";
        state.itemAlertsData = null;
      });
  }
});

export default itemAlertsSlice.reducer;
